var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTextalignJustifycenter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 4.375H2.5C2.15833 4.375 1.875 4.09167 1.875 3.75C1.875 3.40833 2.15833 3.125 2.5 3.125H17.5C17.8417 3.125 18.125 3.40833 18.125 3.75C18.125 4.09167 17.8417 4.375 17.5 4.375Z",
    fill: "#6C757D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 8.54297H2.5C2.15833 8.54297 1.875 8.25964 1.875 7.91797C1.875 7.5763 2.15833 7.29297 2.5 7.29297H17.5C17.8417 7.29297 18.125 7.5763 18.125 7.91797C18.125 8.25964 17.8417 8.54297 17.5 8.54297Z",
    fill: "#6C757D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 12.707H2.5C2.15833 12.707 1.875 12.4237 1.875 12.082C1.875 11.7404 2.15833 11.457 2.5 11.457H17.5C17.8417 11.457 18.125 11.7404 18.125 12.082C18.125 12.4237 17.8417 12.707 17.5 12.707Z",
    fill: "#6C757D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 16.875H2.5C2.15833 16.875 1.875 16.5917 1.875 16.25C1.875 15.9083 2.15833 15.625 2.5 15.625H17.5C17.8417 15.625 18.125 15.9083 18.125 16.25C18.125 16.5917 17.8417 16.875 17.5 16.875Z",
    fill: "#6C757D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTextalignJustifycenter);
export default __webpack_public_path__ + "static/media/textalign-justifycenter.5036331282554d5fcaf3102b34a8a99a.svg";
export { ForwardRef as ReactComponent };